<template>
  <div class="-mb-inset-bottom pb-inset-bottom bg-charcoal-100 dark:bg-dark-950">
    <div class="font-medium text-xs text-left leading-snug p-4 overflow-auto max-h-[40vh]">
      <div class="bg-white dark:bg-dark-800 dark:text-dark-50 p-6 min-h-24 flex items-center justify-center rounded-xl text-center relative text-light-950 shadow">
        <IconBase name="cute/spinner" class="spin text-charcoal-400" v-if="!error" />
        <div v-else>
          {{ $t(`errors.${error.error ?? 'error'}`) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import UserStore from '@/store/user'
import EventsStore from '@/store/events'
import { Event, IEvent, Result } from '@/classes'
import { Err } from '@/classes'

const props = defineProps<{
  event: Event
}>()

const { event } = toRefs(props)

const emit = defineEmits<{
  (e: 'next'): void
  (e: 'error', v: Err): void
  (e: 'previous'): void
}>()

const userStore = UserStore()
const eventStore = EventsStore()
const { currentUser } = storeToRefs(userStore)

const route = useRoute()
const router = useRouter()

const error: Ref<Err | null> = ref(null)

onMounted(async () => {
  const paymentId = route.query.payment_intent
  const tokenId = route.query.token_id

  router.replace({ query: { ...route.query, payment_intent: undefined, payment_intent_client_secret: undefined, redirect_status: undefined, token_id: undefined } })

  const response: Result<{ success: boolean, event: IEvent }> = await fetchAPI('event/checkout/complete', { paymentId, tokenId }, { method: 'POST' })

  if (response.ok) {
    eventStore.setItem(response.data.event, { priority: 5 })

    emit('next')
  } else {
    error.value = response
  }
})
</script>